
export const en = {
  custom_page_source: 'https://www.reedexpo.co.jp/en/online_visitormanual/',
};

export const ja = {
  custom_page_source: 'https://www.reedexpo.co.jp/online_visitormanual/',
};
